import React from "react"
import { usePageHeaderContext } from "../page-header/page-header-context"

// =============================================================================
// Props
// =============================================================================

export type PageSecondaryHeaderHeadingProps = {
  children?: React.ReactNode
}

// =============================================================================
// Component
// =============================================================================

/**
 * Secondary page header heading.
 *
 * Visually hidden to provide an accessible heading for the page without impacting the visual design.
 *
 * The heading should be unique to the page.
 */
export function PageSecondaryHeaderHeading({
  children
}: PageSecondaryHeaderHeadingProps) {
  const { headingId } = usePageHeaderContext()
  return (
    <h1 className="sr-only" id={headingId}>
      {children}
    </h1>
  )
}
